import { ReadinessMathCtrl } from './readiness-math.controller';

export const ReadinessMathStepComponent = {
  controller: ReadinessMathCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./readiness-math.html'),
};
